import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import  { isEmpty } from 'lodash'
import SideBar from '../../../commonModules/layouts/SideBar';

import Spin from '../../../commonModules/interface/Spin.jsx';

import Inventory from './inventory.jsx';
import Products from './Products.jsx';
import Shops from './Shops.jsx';
import Stocks from './stocks.jsx';
import Sales from './Sales.jsx';
import Quote from './Quote.jsx';
import ReapproIntern from './ReapproIntern';
import ReapproInternDraft from './ReapproInternDraft';
import ReapproExtern from './ReapproExtern';
import Purchases from './Purchases.jsx';
import SAV from './SAV.jsx';
import Stats from './Stats.jsx';
import Returns from './Returns';
import Notif from '../../../commonModules/interface/Notif';
import StockCommercials from './StockCommercials';
import Orders from './Orders';

import { createClient, updateClient } from '../../../../../../jsx/actions/clientAction';
import { fetchSavSchemas } from '../../../../../../jsx/actions/paygAction';
import { createReapproExt } from '../../../../../../jsx/actions/reapproExtAction';
import { fetchAgents, updateAgent } from '../../../../../../jsx/actions/paygAction';
import { fetchSociety } from '../../../../../../jsx/actions/authAction';

import { 
    fetchAll, 
    fetchAllPart1,
    fetchAllPart2,
    fetchAllPart3, 
} from '../../../../../../jsx/actions/stockInitAction';

import { 
    fetchTransferDetails,
    fetchTranferTypes 
} from '../../../../../../jsx/actions/transferAction'

import { 
    getAllSAV, 
    updateSav 
} from '../../../../../../jsx/actions/savAction';

import { 
    getAllPhotos, 
    getPhotoProd, 
    createProduct, 
    updateProduct,
    deleteProduct,
    DuplicateProductFromID,
    fetchProducts,
    updatePhotosProduct,
    addPhotosProduct,
    duplicateProduct,
    resetProductState,
} from '../../../../../../jsx/actions/productAction';
import { 
    createBin,
    updateBin
} from '../../../../../../jsx/actions/recyclingAction';

import { 
    createPurchase, 
    receivePurchase, 
    deletePurchase,
    createArrivage, 
    updateArrivage, 
    createDemand, 
    deleteArrivage, 
    deleteDemand, 
    linkPurchasesTo5000,
    unLinkPurchasesTo5000,
    updatePurchase,
} from '../../../../../../jsx/actions/purchaseAction';

import { 
    createSale, 
    receiveReappro, 
    validatePrepa, 
    deletePrepa, 
    deleteSale, 
    deleteReappro,
    linkSalesTo5000, 
    unLinkSalesTo5000,  
} from '../../../../../../jsx/actions/saleAction';
import { 
    createResaDemand, 
    makeResa,
    createSaleFromResa,
    deleteResa, 
    fetchResas
} from '../../../../../../jsx/actions/resaAction';
import { 
    createInstall, 
    createSaleFromInstall,
    deleteInstall, 
} from '../../../../../../jsx/actions/installAction';

import { 
    getAllReturnProducts, 
    getAllReturnStocks, 
    getAllReturnSales, 
    createReturnProduct, 
    deleteReturnProduct, 
    deleteReturnSale,
    createReturnSale 
} from '../../../../../../jsx/actions/returnAction';

import { 
    getPhotoShop, 
    createShop, 
    updateShop,
    updateShopLogo,
} from '../../../../../../jsx/actions/shopAction';

import { 
    fetchCommercialReas, 
    fetchCommercialStocks, 
    createCommercialRea, 
    deleteCommercialRea 
} from '../../../../../../jsx/actions/commercialReaAction';

import {
    fetchCommercialReturns, 
    createCommercialReturn, 
    deleteCommercialReturn 
} from '../../../../../../jsx/actions/commercialReturnAction';

import { 
    fetchOrders, 
    validateOrder 
} from '../../../../../../jsx/actions/orderAction';
import { fetchUsers } from '../../../../../../jsx/actions/paygAction';
import { fetchSaleCredits, createSaleCredit, deleteCredit, linkCreditPaymentsTo5000 } from '../../../../../../jsx/actions/saleCreditsAction';
import { getIncomeInfo, getSpendingInfo } from '../../../../../../jsx/actions/paymentAction';

import { StorageRounded, Description, HomeRounded, ShoppingCartRounded, ReceiptRounded, PersonPinCircleRounded, SwapHorizRounded, SwapVertRounded, RestoreRounded, LaptopMacRounded, PieChartRounded, StoreRounded, BuildRounded, ScheduleRounded, UndoRounded, BookmarkRounded, AccountCircleRounded, SettingsRounded, MonetizationOnOutlined, StyleRounded, LocalOfferRounded, TextureRounded, FileCopy } from '@material-ui/icons';
import CardPage from '../../../commonModules/layouts/CardPage';
import Arrivages from './Arrivages';
import Reservations from './Reservations';
import Clients from './Clients';
import Installations from './Installation';
import Credits from './Credits';
import Recycling from './Recycling';
import PreviewLoc from './localisations/PreviewLoc';
import ResaDemands from './ResaDemands';
import Avoirs from './Avoirs';

class StockDashboard extends Component {
    state = { 
        page:"home",
        new: false,
        notif:{
            title:"", 
            type:"", 
            message:"",
            show: false,
        },
    }
    componentDidMount = async () => {
        console.log("MOUNTING Main Stock ");
        if(!this.props.fetched) {
            await this.props.fetchAllPart1()  
        //     await this.props.fetchAllPart2()  
        //     this.props.fetchAllPart3()  
        //     // this.props.fetchAll()  
        }

        if( isEmpty(this.props.AGENTS) ){
            this.props.fetchAgents()
        }
        if( isEmpty(this.props.SOCIETY) ){
            this.props.fetchSociety()
        }
    }

    changePage = (page, openNew = false) => {
        this.setState({
            page: page,
            new: openNew
        })
    }
    // notif = (show, type = "", msg = "", title = "") => {
    //     this.setState({
    //         notif: {
    //             title, 
    //             type, 
    //             message:msg,
    //             show,
    //         }
    //     })
    // }
    render() {
        const {loading, errorPage} = this.props
        const { show, message, title, type} = this.state.notif;
        const { page } = this.state;

        // console.log('====================================');
        // console.log("StockDashboard",this.props);
        // console.log('====================================');

        let menu = [
            { name : "home", title: "Home", icon : <HomeRounded color={(page === "home" ? "secondary" : "")}/> },
            { name : "prods", title: "Produits", icon : <LocalOfferRounded color={(page === "prods" ? "secondary" : "")} /> },
            { name : "shops", title: "Magasins", icon : <StoreRounded color={(page === "shops" ? "secondary" : "")}/> },
            { name : "stocks", title: "Stocks", icon : <StorageRounded color={(page === "stocks" ? "secondary" : "")}/> },
            { name : "clients", title: "Clients", icon : <AccountCircleRounded color={(page === "clients" ? "secondary" : "")}/> },
            { name : "arrivages", title: "Arrivages", icon : <ScheduleRounded color={(page === "arrivages" ? "secondary" : "")}/> },
            // { name : 
            //     "arrivages", 
            //     title: "Arrivages", 
            //     icon : <ScheduleRounded  color={(page === "arrivages" ? "secondary" : "")}/> ,
            //     sub: [
            //         { name : "arrivages", title: "Arrivages"},
            //         { name : "demands", title: "Demandes"},
            //     ]
            // },
            { name : "purchases", title: "Achats", icon : <ShoppingCartRounded color={(page === "purchases" ? "secondary" : "")}/> },
            // { 
            //     name : "resa", 
            //     title: "Reservation", 
            //     icon : <BookmarkRounded  color={(page === "resa" ? "secondary" : "")}/> ,
            //     sub: [
            //         { name : "demands", title: "Mes Reservations", },
            //         { name : "demands", title: "En attente", }, // for admin
            //         { name : "resa", title: "En cours"}, // for Admin
            //     ]
            // },
            { name : "resa", title: "Réservation", icon : <BookmarkRounded  color={(page === "resa" ? "secondary" : "")}/> },
            { name : "install", title: "Installation", icon : <BuildRounded  color={(page === "install" ? "secondary" : "")}/> },
            { name : "quote", title: "Cotation", icon : <Description color={(page === "quote" ? "secondary" : "")}/> },
            { name : "sales", title: "Ventes", icon : <ReceiptRounded color={(page === "sales" ? "secondary" : "")}/> },
            { name : "avoirs", title: "Avoirs", icon : <FileCopy color={(page === "avoirs" ? "secondary" : "")}/> },
            { name : "credits", title: "Crédits", icon : <MonetizationOnOutlined color={(page === "credits" ? "secondary" : "")}/> },
            { name : "commercial", title: "Stock Commerciaux", icon : <PersonPinCircleRounded color={(page === "commercial" ? "secondary" : "")}/> },
            { 
                name : "reappro", 
                title: "Réappro Internes", 
                icon : <SwapHorizRounded  color={(page === "reappro" ? "secondary" : "")}/> ,
                sub: [
                    { name : "reappro", title: "Liste"}, // for Admin
                    { name : "draft", title: "Brouillons", },
                ]
            },
            // { name : "reappro", title: "Réappro", icon : <SwapHorizRounded color={(page === "reappro" ? "secondary" : "")}/>  },
            { name : "reapproExt", title: "Réappro Externes",  icon : <SwapVertRounded color={(page === "reapproExt" ? "secondary" : "")} />  },
            { name : "returns", title: "Occasion", icon : <UndoRounded color={(page === "returns" ? "secondary" : "")}/> },
            { name : "sav", title: "SAV", icon : <SettingsRounded color={(page === "sav" ? "secondary" : "")}/> },
            { name : "recycling", title: "Recyclage", icon : <TextureRounded color={(page === "recycling" ? "secondary" : "")}/> },
            { name : "orders", title: "Commandes", icon : <LaptopMacRounded color={(page === "orders" ? "secondary" : "")}/> },
            { name : "stats", title: "Statistiques", icon : <PieChartRounded color={(page === "stats" ? "secondary" : "")}/> },
        ]

        return (
            <div>
                {loading && <Spin />}
                {(show && message) &&
                    <Notif
                        show={show} 
                        title={title} 
                        type={type} 
                        message={message} 
                        close={() => this.notif(false)} 
                    />
                }
                {errorPage &&
                    <CardPage title="Erreur de Connexion" storehouse >
                        <h3>
                            Magasin Indisponible: <small>Veuillez rééssayer plus tard</small>
                        </h3>
                    </CardPage>
                }
                {!errorPage &&
                    <SideBar menu={menu} page={page} changePage={this.changePage}>
                        {page === "home" && 
                            <Inventory {...this.props} changePage={this.changePage} />
                            // <PreviewLoc />
                            // <Installations  {...this.state} {...this.props} />
                        }
                        {page === "prods" && 
                            <Products {...this.state} {...this.props} /> 
                        }
                        {page === "shops" && 
                            <Shops {...this.state} {...this.props} /> 
                        }
                        {page === "stocks" && 
                            <Stocks {...this.state} {...this.props} /> 
                        }
                        {page === "commercial" && 
                            <StockCommercials {...this.state} {...this.props} /> 
                        }
                        {page === "arrivages" && 
                            <Arrivages {...this.state} {...this.props} /> 
                        }
                        {page === "purchases" && 
                            <Purchases {...this.state} {...this.props} /> 
                        }
                        {page === "sales" && 
                            <Sales {...this.state} {...this.props} /> 
                        }
                        {page === "quote" &&
                            <Quote {...this.state} {...this.props} /> 
                        }
                        {page === "avoirs" && 
                            <Avoirs  {...this.state} {...this.props} /> 
                        }
                        {page === "resa" && 
                            // <Reservations {...this.state} {...this.props} /> 
                            <ResaDemands {...this.props} />
                        }
                        {page === "install" && 
                            <Installations {...this.state} {...this.props} /> 
                        }
                        {page === "reappro" && 
                            <ReapproIntern {...this.state} {...this.props} /> 
                        }
                        {page === "draft" && 
                            <ReapproInternDraft {...this.state} {...this.props} /> 
                        }
                        {page === "reapproExt" && 
                            <ReapproExtern {...this.state} {...this.props} /> 
                        }
                        {page === "clients" && 
                            <Clients {...this.state} {...this.props} /> 
                        }
                        {page === "returns" && 
                            <Returns {...this.props} /> 
                        }
                        {page === "sav" && 
                            <SAV {...this.props} /> 
                        }
                        {page === "orders" && 
                            <Orders {...this.props} /> 
                        }
                        {page === "stats" && 
                            <Stats {...this.props} /> 
                        }
                        {page === "credits" && 
                            <Credits {...this.props} /> 
                        }
                        {page === "recycling" && 
                            <Recycling {...this.props} /> 
                        }
                    </SideBar>
                }
            </div>
        );
    }
}

function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
        PRODUCTS: state.inventory.products,
        SHOPS: state.inventory.shops,
        STOCKS: state.inventory.stocks,
        AVAILABLE: state.inventory.stocks.AVAILABLE,
        OCCASION: state.inventory.stocks.OCCASION,
        RESERVATION: state.inventory.stocks.RESERVATION,
        WAITING: state.inventory.stocks.WAITING_DELIVERY,
        SALES: state.inventory.sales.SALES,
        QUOTES: state.inventory.quotes.QUOTES,
        REAPPRO: state.inventory.sales.REAPPRO,
        REAPPRO_EXT: state.inventory.sales.REAPPRO_EXT,
        REA_DRAFTS: state.inventory.sales.REA_DRAFTS,
        PURCHASES: state.inventory.purchases.PURCHASES,
        PURCHASES_REAPPRO: state.inventory.purchases.REAPPRO,
        AVOIRS: state.inventory.avoirs,

        ORDERS: state.orders,
        CLIENTS: state.inventory.clients,
        PAYG_CLIENTS: state.clients,
        RETURNS: state.inventory.returns,
        RETURNSALES: state.inventory.returnSales,
        SAV: state.inventory.sav,
        SAV_SCHEMAS: state.schemas.SAV,

        COMMERCIAL_REAS: state.inventory.commercialReas,
        COMMERCIAL_STOCKS: state.inventory.commercialStocks,
        COMMERCIAL_RETURNS: state.inventory.commercialReturns,

        ARRIVAGES: state.inventory.arrivages,
        DEMANDS: state.inventory.demands,

        RESAS: state.inventory.resas,
        INSTALLS: state.inventory.installs,

        AGENTS: state.agents.agents,
        USERS: state.users,
        SALE_CREDITS: state.inventory.credits,

        CITY_STATS: state.stats.CITY_STATS,
        TOP_PRODUCTS: state.stats.TOP_PRODUCTS,

        errorPage: state.inventory.state.error,
        loading: state.inventory.state.fetching,
        fetched: state.inventory.state.fetched,
        stateProducts: state.inventory.requestState.products,
        photoFetched: state.inventory.requestState.photos.fetched,
        STATE: state.inventory.requestState,
        isSuperAdmin: state.auth.isSuperAdmin,
        SOCIETY: state.society,
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
        fetchAll,
        fetchAllPart1,
        fetchAllPart2,
        fetchAllPart3,

        getAllSAV,
        updateSav,
        fetchSavSchemas,

        getAllReturnProducts,
        getAllReturnStocks, 
        getAllReturnSales,
        createReturnProduct,
        createReturnSale,
        deleteReturnProduct,
        deleteReturnSale,
        
        createShop,
        updateShop,
        updateShopLogo,
        getPhoto: getPhotoShop,
        
        getPhotoProd,
        getAllPhotos,
        createProduct,
        updateProduct,
        deleteProduct,
        updatePhotosProduct,
        addPhotosProduct,
        duplicateProduct,
        resetProductState,

        fetchTransferDetails,
        fetchTranferTypes,
        
        createPurchase,
        receivePurchase, 
        receiveReappro, 
        updatePurchase,
        deletePurchase,
        createArrivage,
        updateArrivage,
        createDemand,
        deleteArrivage,
        deleteDemand,
        
        createClient,
        updateClient,
        
        createSale,
        validatePrepa,
        deletePrepa,
        deleteSale,
        
        deleteReappro,
        
        createReapproExt,
        
        createResaDemand,
        makeResa,
        createSaleFromResa,
        deleteResa,
        // fetchResas,
        
        createInstall,
        createSaleFromInstall,
        deleteInstall,

        fetchAgents, 
        updateAgent,

        fetchCommercialReas, 
        createCommercialRea,
        deleteCommercialRea,

        
        fetchProducts,
        fetchCommercialReturns,
        fetchCommercialStocks,
        createCommercialReturn,

        fetchOrders,
        validateOrder,

        fetchUsers,
        fetchSaleCredits,
        createSaleCredit,
        deleteCredit,
        linkCreditPaymentsTo5000,

        linkSalesTo5000,
        unLinkSalesTo5000,
        getIncomeInfo,
        
        linkPurchasesTo5000,
        unLinkPurchasesTo5000,
        getSpendingInfo,
        createBin,
        updateBin,
        fetchSociety,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(StockDashboard);